import { createContext } from 'react';

const ContentContext = createContext();

export default ContentContext;